
import React from 'react';
import MainContent from '../MainComponents/mainContent';
import './page1.css'
import SideBars from './../MainComponents/sidebar';
import TitleJumper from '../MainComponents/titleJumper';
import MyMenu from '../Menu/menu';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
// import $ fro

export default class Page1 extends React.Component{
    
    constructor(props){
        super(props)
        this.state={
            showTest:false,
            menuTest:<></>
        }
        this.showMenuTest=this.showMenuTest.bind(this)
        this.deleteMenuTest=this.deleteMenuTest.bind(this)
        this.updateSize=this.updateSize.bind(this)
        this.clearSize=this.clearSize.bind(this)
    }
    componentDidUpdate(){

        // console.log('inynpad2')
    //    if(this.state.showTest) {
    //     this.updateSize()
    //    }else {
           
    //    this.clearSize()
    //    }
    }
    clearSize(){
        // let element=document.getElementById("menus")
        
            // if(element){
                // console.log(element.offsetHeight)
            document.getElementById("mm").style.marginTop="0px"
            document.getElementById('sid').style.top="0px"
            document.getElementById('openDrawer').style.top="0px"
        // }
    }

    componentDidMount() {
        
        // console.log('inynpad')
    }
    updateSize(){
        
        // console.log('menu-keeper')
        let element=document.getElementById("menus")
        
            if(element){
                // console.log(element.offsetHeight)
            document.getElementById("mm").style.marginTop=element.offsetHeight+"px"
            document.getElementById('sid').style.top=element.offsetHeight+"px"
            
            document.getElementById('openDrawer').style.top=element.offsetHeight+"px"
        }
            
        // }
    }

    showMenuTest(){
        this.setState({
            showTest:true,
            menuTest:<MyMenu></MyMenu>
    //         menuTest:<ReactCSSTransitionGroup
    //         // transitionName={ {
    //         //     enter: 'animatedBounceFast',
    //         //     enterActive: 'animatedBounceFast',
    //         //     leave: 'animatedBounceFast',
    //         //     leaveActive: 'animatedBounceFast',
    //         //     appear: 'example-appear',
    //         //     appearActive: 'animatedBounceFast'
    //         //   } }
    //         transitionName="example"
    //         transitionAppear={true}
    //         // appear= {'animated bounce fast'}
    // //   transitionAppearTimeout={500}
    //   transitionEnter={false}
    //   transitionLeave={false}
    //   >
    //         <MyMenu className="animated bounce fast"></MyMenu>
    //       </ReactCSSTransitionGroup>
        })
        
    }
    deleteMenuTest(){
        this.setState({
            showTest:false,
            menuTest:<></>
        })
        // this.updateSize()
    }
    
    render(){
        

        return(
            <>
             {/* <div id="menu-keeper">{this.state.menuTest}</div> */}
            <div className="container-fluid" id="mm" style={{position:"relative"}}>
                <div className="row  flex-xl-nowrap">
                <TitleJumper></TitleJumper>
                <MainContent 
                showMenu={this.showMenuTest} 
                deleteMenu={this.deleteMenuTest}>
                    
                </MainContent>
                <SideBars></SideBars>
                </div>
            </div>
            </>

        )
    }
}